import { setEmailSearch } from '../State/emailSearch';

export default () => async (dispatch) => {

  dispatch(setEmailSearch(''));
  
}